<template>
    <div class="kidzonet-vuetify-switcher-overrides">
        <v-switch
            v-bind="$attrs"
            class="policy-options-content-switch"
            color="primary"
            inset
            hide-details
            aria-label="policy switcher"
        />
    </div>
</template>

<style>
    @import '@kidzonet/styles-vuetify-switcher'
</style>

<style>
    .policy-options-content-switch {
        flex-grow: 0;

        .v-switch__thumb {
            color: #fff!important;
        }
    }
</style>
